import React from 'react'
import { useSelector } from 'react-redux'



export default function YourGifts() {
    const user = useSelector((state) => state.user)

    const gift=JSON.parse(localStorage.getItem('yourgift'));

    return (
        <div className=' w-full md:w-2/3 flex md:flex-row-reverse justify-center flex-wrap'>

        {
            gift.username === user.userName ?
               ( 
                
                    <div>
                        <img className='md:w-44 md:h-44 w-36 h-36' src={gift.gift} alt={gift.gift} />
                    </div>
                
                )
            :
            (
                null
            )
        }
            


        </div>
    )
}
